import { Directive } from '@angular/core';
import {NG_VALIDATORS } from '@angular/forms';
import { mobileValidator } from '../../../routes/jy-commons/settings/validators/validators';

@Directive({
  selector: '[mobile]',
  providers :[{
    provide : NG_VALIDATORS,
    useValue : mobileValidator,
    multi: true
  }],
})
export class MobilePhoneDirective {

  constructor() { }

}
